import React from "react";
import "./loader.css";

function Loader(props) {
  const { loaderMessage } = props;
  return (
    <div className="loaderStyle">
      <span className="circle"></span>
      <h4 className="loading">{loaderMessage}</h4>
    </div>
  );
}

export default Loader;
